export default "__VITE_ASSET__DMDBE0nV__"